import { get, post, patch, del } from './client.js';

export const listAll   = ()        => get('/platform/workspaces');
export const getOne    = (id)      => get(`/platform/workspaces/${id}`);
export const update    = (id, body)=> patch(`/platform/workspaces/${id}`, body);
export const suspend   = (id)      => post(`/platform/workspaces/${id}/suspend`);
export const activate  = (id)      => post(`/platform/workspaces/${id}/activate`);
export const archive   = (id)      => post(`/platform/workspaces/${id}/archive`);
export const remove    = (id)      => del(`/platform/workspaces/${id}`);
